export default __webpack_public_path__ + "static/media/mc.30e30e5e.jpg";